import { useCurrentStateAndParams } from "@uirouter/react";

import { Flex } from "@similarweb/ui-components/foundations";

import { usePeriodOverPeriod } from "app/components/duration-selector/period-over-period/usePeriodOverPeriod";
import { useSelectorTrigger } from "app/components/filters-bar/useSelectorTrigger";

import GrowthDriversTable from "./components/GrowthDriversTable/GrowthDriversTable";
import MarketingFocusTable from "./components/MarkteingFocusTable/MarketingFocusTable";
import useMarketingChannelsPresets from "./hooks/useMarketingChannelsPresets";
import useSubtitleFilters from "./hooks/useSubtitleFilters";
import { getComparisonParams } from "./tests/helpers";

const MarketingChannelsPresets = () => {
    const { params } = useCurrentStateAndParams();
    const { labelKey, periodOverPeriodCompareTypes } = usePeriodOverPeriod();
    const growthDriversSubtitleTriggers = useSelectorTrigger("mmx-growth-drivers");
    const marketingFocusSubtitleTriggers = useSelectorTrigger("mmx-marketing-focus");

    const { isPoP, resolvedDuration, defaultDuration } = getComparisonParams(
        labelKey,
        periodOverPeriodCompareTypes,
        params.comparedDuration,
    );

    const { absoluteData, percentageData, isLoading, domains } = useMarketingChannelsPresets(resolvedDuration);
    const { subTitleFilters: growthDriversSubTitleFilters } = useSubtitleFilters(
        resolvedDuration || defaultDuration,
        growthDriversSubtitleTriggers.selectorHandlers,
    );
    const { subTitleFilters: marketingFocusSubTitleFilters } = useSubtitleFilters(
        resolvedDuration || defaultDuration,
        marketingFocusSubtitleTriggers.selectorHandlers,
    );

    return (
        <Flex gap="24px">
            <GrowthDriversTable
                data={absoluteData}
                subTitleFilters={growthDriversSubTitleFilters}
                isLoading={isLoading}
                domains={domains}
                isPoP={isPoP}
            />
            <MarketingFocusTable
                data={percentageData}
                subTitleFilters={marketingFocusSubTitleFilters}
                isLoading={isLoading}
                domains={domains}
                isPoP={isPoP}
            />
        </Flex>
    );
};

export default MarketingChannelsPresets;
